import {Tracker} from '@udemy/event-tracking';

import {CERTIFICATE_TRACKING_EVENTS, EVENT_LABEL} from '../../constants';

export interface Badge {
    name: string;
}

export const sendCertificateSearchEvent = (
    searchQuery: string | undefined,
    filteredByIssuers: string[],
    filteredBySubjectAreas: string[],
) => {
    const eventData = {
        searchQuery,
        filteredByIssuers,
        filteredBySubjectAreas,
    };
    Tracker.publishEvent(new CERTIFICATE_TRACKING_EVENTS.CERTIFICATE_SEARCH_EVENT(eventData));
};

export const sendCertificateTopicPageSelectEvent = (certificateName: string) => {
    const eventData = {
        name: certificateName,
    };
    Tracker.publishEvent(
        new CERTIFICATE_TRACKING_EVENTS.CERTIFICATE_SELECT_EVENT(
            EVENT_LABEL.SELECT_CERTIFICATE_ON_TOPIC_PAGE,
            eventData,
        ),
    );
};
